import { withStyles } from '@material-ui/core';
import { memo } from 'react';
import styles from './styles';
import { AddRounded as AddRoundedIcon } from '@material-ui/icons';
import { PICKUP_MANAGEMENT_MODES } from '../../../PickupManagement/constants';
import StyledToolTip from '../../../../../../../common/StyledToolTip';
const CreatePickup = ({ classes, eventHub, configJSON }) => {

  const onCreatePickupEvent = () => {
    eventHub.emit('pickupManagement', {
      action: PICKUP_MANAGEMENT_MODES.CREATE_PICKUP
    });
  };
  const isCreatePickupEnabled = configJSON.enableCreatePickup;
  return (
    <div
      className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${
        isCreatePickupEnabled ? classes.enabledIcon : classes.disableIcon
      }`}
      onClick={isCreatePickupEnabled ? onCreatePickupEvent : null}>
      <StyledToolTip title={isCreatePickupEnabled ? 'Create Pickup' : 'Create Pickup (Disabled)'}>
        <AddRoundedIcon />
      </StyledToolTip>
    </div>
  );
};

export default withStyles(styles)(memo(CreatePickup));
